import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content selectedVolume"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "volume" }
const _hoisted_5 = { class: "layerSplit" }
const _hoisted_6 = { class: "layers" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "layers" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "additionalSources"
}
const _hoisted_12 = { class: "description" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "content"
}
const _hoisted_15 = { class: "volumes" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "description" }
const _hoisted_18 = { class: "layerSplit" }
const _hoisted_19 = { class: "layers" }
const _hoisted_20 = { class: "layers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.volumes.length)
    ? (_openBlock(), _createBlock($setup["ModalOverlay"], {
        key: 0,
        class: "volumeSelector",
        onHide: _cache[3] || (_cache[3] = ($event: any) => ($setup.emit('hide')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "exit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('hide')))
          }, "×"),
          ($setup.selectedVolume)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    class: "back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectedVolumeName = undefined))
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, "arrow_back", -1 /* HOISTED */)
                  ])),
                  _createElementVNode("div", _hoisted_3, _toDisplayString($setup.selectedVolume.name), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", null, "Select Image Source", -1 /* HOISTED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedVolume.image_layers, (layer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => ($setup.selectedImageSource = layer.source[0]),
                          class: _normalizeClass({
              selected: layer.source === $setup.selectedImageLayer?.source,
              active: $setup.activeLayers.has(layer.source[0])
            })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(layer.name), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(layer.description), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_7))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", null, "Select Segmentation", -1 /* HOISTED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.selectedVolume.segmentation_layers, (layer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: ($event: any) => ($setup.selectedSegmentationSource = layer.source[0]),
                          class: _normalizeClass({
                selected: layer.source === $setup.selectedSegmentationLayer?.source,
                active: $setup.activeLayers.has(layer.source[0])
              })
                        }, [
                          _createElementVNode("div", null, _toDisplayString(layer.name), 1 /* TEXT */),
                          (layer.skeleton_source)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Additional sources: skeletons"))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(layer.description), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_10))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  disabled: !$setup.canConfirm,
                  class: "confirmSelection fill test",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.confirmSelection()))
                }, "Confirm", 8 /* PROPS */, _hoisted_13)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header" }, [
                  _createElementVNode("div", { class: "title" }, "Available Volumes")
                ], -1 /* HOISTED */)),
                _createElementVNode("ul", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.volumes, (volume) => {
                    return (_openBlock(), _createElementBlock("li", {
                      onClick: ($event: any) => ($setup.selectVolume(volume.name))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
            selected: volume.name === $setup.selectedVolumeName,
            active: $setup.activeVolumes.has(volume.name)
          })
                      }, [
                        _createElementVNode("div", null, _toDisplayString(volume.name), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(volume.description), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volume.image_layers, (layer) => {
                              return (_openBlock(), _createElementBlock("div", null, _toDisplayString(layer.name), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(volume.segmentation_layers, (layer) => {
                              return (_openBlock(), _createElementBlock("div", null, _toDisplayString(layer.name), 1 /* TEXT */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ])
                      ], 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_16))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ])
              ]))
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}